import { CSSProperties } from "react";

export const style: CSSProperties = {
  color: "red",
  marginLeft: 1,
  marginTop: 0.2,
  marginBottom: -0.8,
};
